import Model from "../../Model";

export interface TReport7NumericalValue {
  applicantId: number;
  attributeCode: string;
  formAttributeId: number;
  formSectionId: number;
  sectionName: string;
  orderNumber: number;
  qualifierCode: string;
  valueN: number;
}

export interface IReport7NumericalValue extends TReport7NumericalValue {}

const Report7NumericalValue = Model(
  (model: TReport7NumericalValue): IReport7NumericalValue => {
    const _report7NumericalValue: TReport7NumericalValue = Object.assign(
      {},
      model
    );

    return {
      get applicantId() {
        return _report7NumericalValue.applicantId;
      },
      set applicantId(value) {
        _report7NumericalValue.applicantId = value;
      },
      get attributeCode() {
        return _report7NumericalValue.attributeCode;
      },
      set attributeCode(value) {
        _report7NumericalValue.attributeCode = value;
      },
      get formAttributeId() {
        return _report7NumericalValue.formAttributeId;
      },
      set formAttributeId(value) {
        _report7NumericalValue.formAttributeId = value;
      },
      get formSectionId() {
        return _report7NumericalValue.formSectionId;
      },
      set formSectionId(value) {
        _report7NumericalValue.formSectionId = value;
      },
      get sectionName() {
        return _report7NumericalValue.sectionName;
      },
      set sectionName(value) {
        _report7NumericalValue.sectionName = value;
      },
      get orderNumber() {
        return _report7NumericalValue.orderNumber;
      },
      set orderNumber(value) {
        _report7NumericalValue.orderNumber = value;
      },
      get qualifierCode() {
        return _report7NumericalValue.qualifierCode;
      },
      set qualifierCode(value) {
        _report7NumericalValue.qualifierCode = value;
      },
      get valueN() {
        return _report7NumericalValue.valueN;
      },
      set valueN(value) {
        _report7NumericalValue.valueN = value;
      }
    };
  }
);
export default Report7NumericalValue;
